export const isWeChatBrowser = window.navigator.userAgent.toLowerCase().includes("micromessenger");
